import React, { useEffect, useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import { ISearchPage } from "@/types/FmsTypes";
import { transPgToPagination } from "../../../../base/app/appModel";
import { ICashDetail, ICashFields } from "../../../CashTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { billService } from "../../../../bill/BillService";
import { BillCancelStatusEnum, BillIoFlagEnum, BillPayTypeEnum, BillStatusEnum } from "@/types/FmsEnums";
import { IBillSearch } from "../../../../bill/BillTypes";
import useGlobalModel from "@/model/globalModel";


export const useAlreadyCollectModel = createModel(function () {
  const initSearchParam: ICashFields = {};
  const initDataSource: ICashDetail[] = [];
  const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
  const { user: { shopCode } } = useGlobalModel();
  //查询条件
  const [searchParam, setSearchParam] = useState<ICashFields>(initSearchParam);
  //列表数据源
  const [dataSource, setDataSource] = useState<ICashDetail[]>(initDataSource);
  //表格选中行Key值
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedData, setSelectedData] = useState<ICashDetail>();
  //列表数据源分页参数
  const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

  const [collectDrawerVisible, setCollectDrawerVisible] = useState(false);

  const onSearch = () => {
    loadData({ pageNum: 1 }).then()
  }
  const onReset = () => {
    resetSearchParam()
  }


  const updatePgCfg = (updateParam: TablePaginationConfig) => {
    setPgCfg({ ...pgCfg, ...updateParam })
  }
  const updateSearchParam = (updateParam: ICashFields) => {
    setSearchParam({ ...searchParam, ...updateParam })
  }
  const resetSearchParam = () => {
    setSearchParam(initSearchParam);
    setSelectedRowKeys([]);
    loadData(initPgCfg, {});
  }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }
  const loadData = async (page: ISearchPage = initPgCfg, searchValue: ICashFields = searchParam) => {
    const searchParams: IBillSearch = {
      ...searchValue,
      payType: BillPayTypeEnum.CASH,
      ioFlag: BillIoFlagEnum.IN,
      status: BillStatusEnum.BALANCED,
      cancelStatus: BillCancelStatusEnum.INIT,
      shopCode,
      page: {
        pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
        pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
      }
    }
    let { retData } = await billService.page(searchParams);
    const { records, ...pg } = retData;
    setPgCfg(transPgToPagination(pg));
    setDataSource(records);
        clearSelectData();
  }


  return {
    /***field***/
    searchParam,
    dataSource,
    selectedRowKeys,
    pgCfg,
    selectedData,
    collectDrawerVisible,
    /***method***/
    setDataSource,
    setSelectedRowKeys,
    resetSearchParam,
    updateSearchParam,
    loadData,
    updatePgCfg,
    setCollectDrawerVisible,
    onSearch,
    onReset,
    setSelectedData,
  }
});
